import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import 'bootstrap/dist/css/bootstrap.css';
import Root from './containers/Root'
import configureStore from './store/configureStore'
//import { syncHistoryWithStore } from 'react-router-redux'
import ga from 'react-ga'
import {ga_ID} from './constants'
import createHistory from 'history/createHashHistory'
//HTML5 history
//import useRouterHistory from 'react-router/lib/useRouterHistory'
//import hashHistory from 'react-router/lib/hashHistory'
//https://github.com/ReactTraining/react-router/blob/master/docs/API.md#userouterhistorycreatehistory

//const myHistory =useRouterHistory(createHashHistory)({ queryKey: false }) //no ?_k
//const myHistory=hashHistory;
const history=createHistory();
const store = configureStore(history);

//Google analytics
ga.initialize(ga_ID,{
  //debug: true,
  siteSpeedSampleRate: 100
});
//http://stackoverflow.com/a/34837445
history.listen( location =>  ga.pageview( location.pathname ) );
ReactDOM.render(
  <Root history={history} store={store} />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js